"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getEnvSpecificConfig = getEnvSpecificConfig;
exports.retriable = retriable;
exports.getGaCode = getGaCode;

var _index = require("../index");

var _axios = require("axios");
/**
 * Retrieves environment specific configuration
 *
 * @param {Object} data
 * @param {String} domain
 * @param {String} brand
 * @return {String}
 */


function getEnvSpecificConfig(data, domain) {
  var brand = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null; // check if there is a data for specific domain

  if (data[domain]) {
    return data[domain];
  } // same but without www. variant


  var wwwlessdomain = domain.replace('www.', '');

  if (data[wwwlessdomain]) {
    return data[wwwlessdomain];
  } // get brand specific code


  return data[brand] ? data[brand] : null;
}
/**
 * Retriable Promise implementation
 * @see https://github.com/poetic/retryable-promise
 * @param {function} fn function to retry on fail, returns Promise
 * @param {Object[]} options Special options
 * @param {number} [options[].maxRetry=3] - Max count of retries
 * @param {number} [options[].timeout=1000] - Interval between retries in ms
 * @returns {Promise}
 */


function retriable(fn, options) {
  var _getConfig = (0, _index.getConfig)(),
      REQUEST_RETRY_COUNT = _getConfig.REQUEST_RETRY_COUNT,
      REQUEST_RETRY_DELAY = _getConfig.REQUEST_RETRY_DELAY;

  if (typeof options === 'undefined' || options === null) {
    options = {};
  }

  var maxRetry = options.maxRetry || REQUEST_RETRY_COUNT;
  var retriesLeft = maxRetry;
  var timeout = options.timeout || REQUEST_RETRY_DELAY;

  var retry = function retry() {
    var tryCount = maxRetry - retriesLeft + 1;
    return fn(tryCount).catch(function (err) {
      if ((0, _axios.isCancel)(err)) return null;
      retriesLeft--;

      if (retriesLeft === 0) {
        throw err;
      }

      return new Promise(function (resolve) {
        return setTimeout(function () {
          resolve(retry());
        }, timeout);
      });
    });
  };

  return retry();
}
/**
 * Returns domain specific GA code
 *
 * @param {String} domain
 * @returns {String|null}
 */


function getGaCode(domain) {
  var _getConfig2 = (0, _index.getConfig)(),
      DEFAULT_BRAND = _getConfig2.DEFAULT_BRAND,
      GA_CODES_BY_ENV = _getConfig2.GA_CODES_BY_ENV;

  return getEnvSpecificConfig(GA_CODES_BY_ENV, domain, DEFAULT_BRAND);
}